module.exports = __webpack_public_path__ + "static/media/about.35c0b0ff.jpg";